module.exports = __webpack_public_path__ + "media/images/home-desktop-594f4bbf212e27d0f17d0fe152509af6.jpg";